import i18next, { type ParseKeys, type TFunction, type TOptions } from "i18next";

export type i18nText = I18nText | string;

class I18nText {
  public readonly key: string | string[];
  public readonly options?: TOptions;

  constructor(key: string | string[], options?: TOptions) {
    this.key = key;
    this.options = options;
  }
}

export function getI18nErrorTexts(
  errorId: string,
  params?: TOptions,
  defaultToErrorId = true,
): { message: null | string; title: null | string } {
  if (i18next.exists(`errors.${errorId}`)) {
    if (i18next.exists(`errors.${errorId}.title`) || i18next.exists(`errors.${errorId}.message`))
      return {
        message: getI18nTextIfExists(`errors.${errorId}.message`, params),
        title: getI18nTextIfExists(`errors.${errorId}.title`, params),
      };

    return {
      message: getI18nTextIfExists(`errors.${errorId}`, params),
      title: null,
    };
  }

  return {
    message: defaultToErrorId ? errorId : null,
    title: null,
  };
}

export function getI18nTextIfExists(key: string | string[], options?: TOptions) {
  if (i18next.exists(key)) return i18next.t(key as ParseKeys, options ?? {});

  return null;
}

export function getResolvedText(t: TFunction, i18nTextOrText: I18nText | string) {
  if (i18nTextOrText instanceof I18nText) {
    return t(i18nTextOrText.key as ParseKeys, i18nTextOrText.options ?? {});
  }

  return i18nTextOrText;
}

export function i18nText(key: string | string[], options?: TOptions) {
  return new I18nText(key, options);
}
